declare let THREE: any;
import {ConstantsService} from '../services/constants.service';
import {Injectable} from '@angular/core';

class WallBoundsBoundingBox extends (THREE.Box3 as { new(): any; }) {

  private wallVector = new THREE.Vector3();
  private expandWallVector = new THREE.Vector3();
  private upVector = new THREE.Vector3(0, 1, 0);
  private wallCenter = new THREE.Vector3();

  constructor(private constants: ConstantsService) {
    super();
  }

  private negateIfAbove = (value: number): number => value > 0 ? -value : value;

  calculateForObject(wall, objectSize) {

    const upVec = this.upVector,
      wallYRotation = wall.rotation.y,
      wallVector = this.wallVector,
      expandWallVector = this.expandWallVector,
      wallCenter = this.wallCenter;

    wall.updateMatrixWorld();

    wall.getWorldPosition(wallCenter);

    const {depth, height, width} = wall.userData.config.firstPoint;
    const deckHeight = 0;

    wallCenter.y += deckHeight / 2;

    wallVector.set(width, height - (deckHeight), depth);
    wallVector.applyAxisAngle(upVec, wallYRotation);
    wallVector.set(
      Math.abs(wallVector.x),
      Math.abs(wallVector.y),
      Math.abs(wallVector.z)
    );

    this.setFromCenterAndSize(wallCenter, wallVector);

    expandWallVector.set(
      -objectSize.length / 2,
      -objectSize.height / 2,
      0
    );
    expandWallVector.applyAxisAngle(upVec, wallYRotation);
    expandWallVector.set(
      this.negateIfAbove(expandWallVector.x),
      this.negateIfAbove(expandWallVector.y),
      this.negateIfAbove(expandWallVector.z)
    );

    this.expandByVector(expandWallVector);
  }

}

@Injectable()
export class WallBoundsBoundingBoxFactory {
  constructor(private constants: ConstantsService) {

  }

  create(): WallBoundsBoundingBox {
    return new WallBoundsBoundingBox(this.constants);
  }
}



// WEBPACK FOOTER //
// ./src/app/custom/WallBoundsBoundingBox.ts